import { render, staticRenderFns } from "./EmailSubmitForm.vue?vue&type=template&id=c2066d88"
import script from "./EmailSubmitForm.vue?vue&type=script&lang=ts"
export * from "./EmailSubmitForm.vue?vue&type=script&lang=ts"
import style0 from "./EmailSubmitForm.vue?vue&type=style&index=0&id=c2066d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports